import * as uiLayout from '../components/common/uiLayout';
import './rtl-forms-fix.css';
import { DESKTOP_BREAKPOINT, navigationContentSx } from '../config/sidebarLayout';
import NavigationShell from '../components/NavigationShell';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  GlobalStyles,
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  TextField,
  Typography,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";
import Swal from "sweetalert2";
import { SSTLI_API_URL } from "../config/apiUrls";




const API_BASE_URL =
  SSTLI_API_URL;





const DARK_BORDER = "#67C99D";
const DARK_TEXT = "#9BE0C1";
const primary = "#057546";
const primaryDark = "#034d31";
const soft = "#f7fbf9";
const border = "#dce8e2";

const PROGRAMS = [
  { value: 0, label: "دبلوم" },
  { value: 1, label: "دورة تأهيلية" },
  { value: 2, label: "دورة تطويرية" }
];

const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
};

const currentUser = getUser();

const getUserGuid = () =>
  String(
    currentUser?.guid ||
      currentUser?.Guid ||
      currentUser?.userGuid ||
      currentUser?.UserGuid ||
      ""
  ).trim();

const n = (value) => {
  const x = Number(value);
  return Number.isFinite(x) ? Math.max(0, Math.trunc(x)) : 0;
};

function SelectDialog({
  open,
  title,
  rows,
  search,
  setSearch,
  loading,
  type,
  onClose,
  onPick
}) {
  const filtered = useMemo(() => {
    const q = String(search || "").trim().toLowerCase();
    if (!q) return rows;

    return rows.filter((row) =>
      [row.code, row.name, row.status, row.registrationStatus]
        .some((v) => String(v || "").toLowerCase().includes(q))
    );
  }, [rows, search]);

  return (
    <Dialog sx={uiLayout.dialogLayoutSx}
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      dir="rtl"
      PaperProps={{
        sx: {
          borderRadius: { xs: 1.5, sm: 2.5 },
          m: { xs: 0.7, sm: 2 },
          maxHeight: { xs: "92vh", sm: "84vh" }
        }
      }}
    >
      <DialogTitle
        sx={{
          py: { xs: 0.75, sm: 1.2 },
          fontWeight: 900,
          fontSize: { xs: 15, sm: 20 }
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent dividers sx={{ p: { xs: 0.65, sm: 1.1 } }}>
        <TextField InputLabelProps={{ shrink: true }}
          autoFocus
          fullWidth
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="بحث..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
          sx={uiLayout.withUiSx({
            mb: 0.65,
            "& .MuiInputBase-root": { minHeight: { xs: 34, sm: 38 } },
            "& input": { fontSize: { xs: 12, sm: 13 } }
          }, uiLayout.formFieldSx)}
        />

        {loading ? (
          <Box sx={{ py: 4, textAlign: "center" }}>
            <CircularProgress size={26} />
          </Box>
        ) : (
          <Box sx={{ display: "grid", gap: 0.4 }}>
            {filtered.map((row, index) => (
              <Paper
                key={`${row.guid || row.code}-${index}`}
                variant="outlined"
                onDoubleClick={() => onPick(row)}
                sx={{
                  p: { xs: 0.55, sm: 0.85 },
                  cursor: "pointer",
                  borderColor: border,
                  "&:hover": {
                    bgcolor: "#eef8f3",
                    borderColor: primary
                  }
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns:
                      type === "branch"
                        ? { xs: "42px minmax(0,1fr) 48px", sm: "70px minmax(0,1fr) 70px" }
                        : { xs: "48px minmax(0,1fr) 48px", sm: "70px minmax(0,1fr) 90px 100px 70px" },
                    alignItems: "center",
                    gap: 0.45
                  }}
                >
                  <Typography sx={{ fontSize: { xs: 12, sm: 12.5 }, fontWeight: 900 }}>
                    {row.code || "-"}
                  </Typography>

                  <Typography
                    noWrap
                    title={row.name}
                    sx={{ fontSize: { xs: 12, sm: 13 }, fontWeight: 800 }}
                  >
                    {row.name || "-"}
                  </Typography>

                  {type !== "branch" && (
                    <>
                      <Typography
                        sx={{
                          display: { xs: "none", sm: "block" },
                          fontSize: 12
                        }}
                      >
                        {row.status || ""}
                      </Typography>

                      <Typography
                        sx={{
                          display: { xs: "none", sm: "block" },
                          fontSize: 12
                        }}
                      >
                        {row.registrationStatus || ""}
                      </Typography>
                    </>
                  )}

                  <Button
                    size="small"
                    onClick={() => onPick(row)}
                    sx={uiLayout.withUiSx({ minWidth: 0, px: 0.2, fontSize: { xs: 12, sm: 12 } }, uiLayout.buttonSx)}
                  >
                    اختيار
                  </Button>
                </Box>
              </Paper>
            ))}

            {!filtered.length && (
              <Alert severity="info" sx={{ fontSize: { xs: 12, sm: 12 } }}>
                لا توجد بيانات مطابقة.
              </Alert>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={uiLayout.withUiSx({ py: 0.35 }, uiLayout.dialogActionsSx)}>
        <Button onClick={onClose} sx={uiLayout.withUiSx({ fontSize: { xs: 12, sm: 13 } }, uiLayout.buttonSx)}>
          إغلاق
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default function BatchCountManagement() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const surfaces = theme.palette.surfaces || {};
  const darkCard = surfaces.card || "#13251d";
  const darkSection = surfaces.section || "#172b22";
  const darkNested = surfaces.nested || "#1b3328";
  const darkHover = surfaces.hover || "#214333";
  const isDesktop = useMediaQuery(
    `(min-width:${DESKTOP_BREAKPOINT}px)`,
    { noSsr: true }
  );

  const userGuid = useMemo(() => getUserGuid(), []);

  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [permissionLoading, setPermissionLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  const [ops, setOps] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canFind: false
  });

  const [branches, setBranches] = useState([]);

  const [branch, setBranch] = useState(null);
  const [programType, setProgramType] = useState("");
  const [batch, setBatch] = useState(null);

  const [mainCount, setMainCount] = useState(0);
  const [specialties, setSpecialties] = useState([]);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [branchDialogOpen, setBranchDialogOpen] = useState(false);
  const [branchSearch, setBranchSearch] = useState("");

  const [batchDialogOpen, setBatchDialogOpen] = useState(false);
  const [batchSearch, setBatchSearch] = useState("");
  const [batchRows, setBatchRows] = useState([]);
  const [batchLoading, setBatchLoading] = useState(false);

  const allocatedCount = useMemo(
    () => specialties.reduce((sum, item) => sum + n(item.count), 0),
    [specialties]
  );

  const remainingCount = Math.max(0, n(mainCount) - allocatedCount);

  const resetBelowBranch = useCallback(() => {
    setProgramType("");
    setBatch(null);
    setMainCount(0);
    setSpecialties([]);
    setBatchRows([]);
    setBatchSearch("");
  }, []);

  const resetBelowType = useCallback(() => {
    setBatch(null);
    setMainCount(0);
    setSpecialties([]);
    setBatchRows([]);
    setBatchSearch("");
  }, []);

  const resetAll = useCallback(() => {
    setBranch(null);
    resetBelowBranch();
  }, [resetBelowBranch]);

  // صلاحية الشاشة نفسها: شئون الطلاب -> ظبط أعداد الدفعات
  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        if (!userGuid) return;

        const response = await fetch(
          `${API_BASE_URL}/api/user-permissions/${encodeURIComponent(userGuid)}`,
          { cache: "no-store" }
        );

        const result = await response.json().catch(() => null);

        const allowed =
          response.ok &&
          result?.data?.studentAffairs?.canView === true &&
          result?.data?.studentAffairs?.screens?.batchCount === true;

        if (alive) setAuthorized(Boolean(allowed));
      } catch {
        if (alive) setAuthorized(false);
      } finally {
        if (alive) setPermissionLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [userGuid]);

  const loadBootstrap = useCallback(async () => {
    if (!authorized || !userGuid) return;

    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/batch-count-management/bootstrap?userGuid=${encodeURIComponent(userGuid)}`,
        { cache: "no-store" }
      );

      const raw = await response.text();
      let result = null;

      try {
        result = raw ? JSON.parse(raw) : null;
      } catch {
        result = null;
      }

      if (!response.ok) {
        throw new Error(
          [result?.message, result?.error, result?.detail]
            .filter(Boolean)
            .join(" — ") ||
            raw ||
            "تعذر تحميل الشاشة"
        );
      }

      setOps({
        canView: Boolean(result?.data?.permissions?.canView),
        canAdd: Boolean(result?.data?.permissions?.canAdd),
        canEdit: Boolean(result?.data?.permissions?.canEdit),
        canFind: Boolean(result?.data?.permissions?.canFind)
      });

      setBranches(
        Array.isArray(result?.data?.branches)
          ? result.data.branches
          : []
      );
    } catch (e) {
      await Swal.fire({
        icon: "error",
        title: "تعذر التحميل",
        text: e?.message || "تعذر تحميل شاشة ظبط أعداد الدفعات"
      });
    } finally {
      setLoading(false);
    }
  }, [authorized, userGuid]);

  useEffect(() => {
    if (authorized) loadBootstrap();
  }, [authorized, loadBootstrap]);

  const loadBatches = useCallback(async () => {
    if (programType === "" || !userGuid) return;

    setBatchLoading(true);

    try {
      const params = new URLSearchParams({
        userGuid,
        programType: String(programType),
        q: batchSearch || ""
      });

      const response = await fetch(
        `${API_BASE_URL}/api/batch-count-management/batches?${params}`,
        { cache: "no-store" }
      );

      const result = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(
          [result?.message, result?.error, result?.detail]
            .filter(Boolean)
            .join(" — ") ||
          "تعذر تحميل قائمة الدفعات"
        );
      }

      setBatchRows(Array.isArray(result?.data) ? result.data : []);
    } catch (e) {
      setBatchRows([]);
      await Swal.fire({
        icon: "error",
        title: "تعذر البحث",
        text: e?.message || "تعذر تحميل قائمة الدفعات"
      });
    } finally {
      setBatchLoading(false);
    }
  }, [programType, userGuid, batchSearch]);

  useEffect(() => {
    if (!batchDialogOpen) return;

    const timer = setTimeout(() => {
      loadBatches();
    }, 220);

    return () => clearTimeout(timer);
  }, [batchDialogOpen, batchSearch, programType, loadBatches]);

  const loadDetails = useCallback(
    async (selectedBatch) => {
      if (!branch || programType === "" || !selectedBatch) return;

      setBatchDialogOpen(false);
      setBatch(selectedBatch);
      setLoading(true);

      try {
        const params = new URLSearchParams({
          userGuid,
          branchGuid: branch.guid,
          batchGuid: selectedBatch.guid,
          programType: String(programType)
        });

        const response = await fetch(
          `${API_BASE_URL}/api/batch-count-management/details?${params}`,
          { cache: "no-store" }
        );

        const raw = await response.text();
        let result = null;

        try {
          result = raw ? JSON.parse(raw) : null;
        } catch {
          result = null;
        }

        if (!response.ok) {
          throw new Error(
            [result?.message, result?.error, result?.detail]
              .filter(Boolean)
              .join(" — ") ||
              raw ||
              "تعذر تحميل بيانات الدفعة"
          );
        }

        setMainCount(n(result?.data?.mainCount));

        setSpecialties(
          Array.isArray(result?.data?.specialties)
            ? result.data.specialties.map((item) => ({
                guid: String(item.guid || ""),
                name: String(item.name || ""),
                count: n(item.count)
              }))
            : []
        );
      } catch (e) {
        setMainCount(0);
        setSpecialties([]);

        await Swal.fire({
          icon: "error",
          title: "تعذر التحميل",
          text: e?.message || "تعذر تحميل أعداد الدفعة"
        });
      } finally {
        setLoading(false);
      }
    },
    [branch, programType, userGuid]
  );

  const setSpecialtyCount = useCallback(
    (guid, value) => {
      const nextValue = n(value);

      setSpecialties((current) => {
        const oldItem = current.find((x) => x.guid === guid);
        const oldValue = n(oldItem?.count);
        const currentTotal = current.reduce(
          (sum, x) => sum + n(x.count),
          0
        );
        const projected = currentTotal - oldValue + nextValue;

        if (projected > n(mainCount)) {
          const allowedForThis =
            Math.max(0, n(mainCount) - (currentTotal - oldValue));

          return current.map((x) =>
            x.guid === guid
              ? { ...x, count: allowedForThis }
              : x
          );
        }

        return current.map((x) =>
          x.guid === guid
            ? { ...x, count: nextValue }
            : x
        );
      });
    },
    [mainCount]
  );

  const save = useCallback(async () => {
    if (!branch) {
      await Swal.fire("تنبيه", "برجاء اختيار الفرع أولًا", "warning");
      return;
    }

    if (programType === "") {
      await Swal.fire("تنبيه", "برجاء اختيار نوع البرنامج أولًا", "warning");
      return;
    }

    if (!batch) {
      await Swal.fire("تنبيه", "برجاء اختيار الدفعة أولًا", "warning");
      return;
    }

    if (!ops.canEdit) {
      await Swal.fire(
        "غير مسموح",
        "لا توجد لديك صلاحية تعديل أعداد الدفعات",
        "error"
      );
      return;
    }

    if (allocatedCount > n(mainCount)) {
      await Swal.fire(
        "راجع الأعداد",
        "إجمالي أعداد التخصصات أكبر من المقاعد المتاحة",
        "warning"
      );
      return;
    }

    const reasonResult = await Swal.fire({
      title: "سبب التعديل",
      input: "textarea",
      inputPlaceholder: "اكتب سبب تعديل أعداد الدفعة...",
      showCancelButton: true,
      confirmButtonText: "حفظ",
      cancelButtonText: "رجوع",
      inputValidator: (value) =>
        !String(value || "").trim()
          ? "سبب التعديل مطلوب"
          : undefined
    });

    if (!reasonResult.isConfirmed) return;

    const payload = {
      actorUserGuid: userGuid,
      branchGuid: branch.guid,
      batchGuid: batch.guid,
      batchCode: String(batch.code || ""),
      programType: Number(programType),
      reason: String(reasonResult.value || "").trim(),
      specialties: specialties.map((item) => ({
        diplomGuid: item.guid,
        count: n(item.count)
      }))
    };

    setSaving(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/batch-count-management`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      const raw = await response.text();
      let result = null;

      try {
        result = raw ? JSON.parse(raw) : null;
      } catch {
        result = null;
      }

      if (!response.ok) {
        throw new Error(
          [result?.message, result?.error, result?.detail]
            .filter(Boolean)
            .join(" — ") ||
            raw ||
            "تعذر الحفظ"
        );
      }

      await Swal.fire({
        icon: "success",
        title: "تم الحفظ",
        text: result?.message || "تم تعديل أعداد الدفعة بنجاح"
      });

      await loadDetails(batch);
    } catch (e) {
      await Swal.fire({
        icon: "error",
        title: "تعذر الحفظ",
        text:
          e?.message ||
          "تعذر حفظ أعداد الدفعة وتم التراجع عن العملية بالكامل"
      });
    } finally {
      setSaving(false);
    }
  }, [
    branch,
    programType,
    batch,
    ops.canEdit,
    allocatedCount,
    mainCount,
    userGuid,
    specialties,
    loadDetails
  ]);

  if (permissionLoading) {
    return (
      <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!authorized) {
    return (
      <Box sx={{ p: 1 }}>
        <Alert severity="error">
          لا توجد لديك صلاحية ظبط أعداد الدفعات ضمن قائمة شئون الطلاب.
        </Alert>
      </Box>
    );
  }

  const page = (
    <Box
      dir="rtl"
      sx={{
        width: "100%",
        maxWidth: "100%",
        minHeight: "100vh",
        overflowX: "hidden",
        bgcolor: soft,
        p: { xs: 0.35, sm: 0.7, md: 1 }
      }}
    >
      <Paper
        elevation={0}
        sx={{
          border: `1px solid ${isDark ? DARK_BORDER : border}`,
          borderRadius: { xs: 1.2, sm: 2 },
          overflow: "hidden",
          "& .MuiInputBase-root": {
            minHeight: { xs: 33, sm: 38 }
          },
          "& .MuiInputBase-input": {
            fontSize: { xs: 12, sm: 13 },
            py: { xs: 0.4, sm: 0.7 }
          },
          "& .MuiInputLabel-root": {
            fontSize: { xs: 12, sm: 12 }
          },
          "& .MuiButton-root": {
            minHeight: { xs: 30, sm: 36 },
            fontSize: { xs: 12, sm: 12.8 }
          }
        }}
      >
        <Box
          sx={uiLayout.withUiSx({
            bgcolor: isDark ? theme.palette.text.primary : primaryDark,
            color: "#fff",
            px: { xs: 0.7, sm: 1.3 },
            py: { xs: 0.55, sm: 0.8 },
            display: "flex",
            alignItems: "center",
            gap: 0.55
          }, uiLayout.mobileHeaderSx)}
        >
          {!isDesktop && (
            <IconButton
              onClick={() => setMobileSidebarOpen(true)}
              sx={{ color: "#fff", p: 0.35 }}
            >
              <MenuRoundedIcon />
            </IconButton>
          )}

          <TuneIcon />

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              sx={{
                fontWeight: 900,
                fontSize: { xs: 15, sm: 19, md: 21 }
              }}
            >
              ظبط أعداد الدفعات
            </Typography>
          </Box>

          <Chip
            size="small"
            label={batch ? `دفعة #${batch.code}` : "إعداد جديد"}
            sx={{
              height: { xs: 21, sm: 27 },
              bgcolor: isDark ? darkCard : "#fff",
              color: isDark ? theme.palette.text.primary : primaryDark,
              fontWeight: 900,
              fontSize: { xs: 12, sm: 12 }
            }}
          />
        </Box>

        <Box
          sx={uiLayout.withUiSx({
            p: { xs: 0.55, sm: 0.8 },
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(2,minmax(0,1fr))",
              md: "repeat(4,minmax(0,1fr))"
            },
            gap: { xs: 0.4, sm: 0.7 },
            borderBottom: `1px solid ${isDark ? DARK_BORDER : border}`
          }, uiLayout.actionBarSx)}
        >
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={resetAll}
            sx={uiLayout.withUiSx({ bgcolor: "#1976d2", fontWeight: 900 }, uiLayout.buttonSx)}
          >
            جديد
          </Button>

          <Button
            variant="contained"
            color="success"
            startIcon={
              saving
                ? <CircularProgress size={14} color="inherit" />
                : <SaveIcon />
            }
            disabled={saving || loading || !ops.canEdit}
            onClick={save}
            sx={uiLayout.withUiSx({ fontWeight: 900 }, uiLayout.buttonSx)}
          >
            حفظ
          </Button>

          <Button
            variant="outlined"
            startIcon={<SearchIcon />}
            onClick={() => {
              setBranchSearch("");
              setBranchDialogOpen(true);
            }}
            sx={uiLayout.withUiSx({
              gridColumn: { xs: "1 / -1", md: "auto" },
              fontWeight: 900
            }, uiLayout.buttonSx)}
          >
            اختيار الفرع
          </Button>

          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "center",
              color: "text.secondary",
              fontSize: 12
            }}
          >
            {loading ? "جاري التحميل..." : ""}
          </Box>
        </Box>

        <Box sx={{ p: { xs: 0.55, sm: 0.9 } }}>
          {/* كل 2 فيلد جنب بعض على الموبايل */}
          <Box
            sx={uiLayout.withUiSx({
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2,minmax(0,1fr))",
                md: "repeat(3,minmax(0,1fr))"
              },
              gap: { xs: 0.4, sm: 0.7 }
            }, uiLayout.formSectionSx)}
          >
            <TextField sx={uiLayout.formFieldSx} InputLabelProps={{ shrink: true }}
              size="small"
              label="الفرع"
              value={branch?.name || ""}
              onClick={() => {
                setBranchSearch("");
                setBranchDialogOpen(true);
              }}
              InputProps={{ readOnly: true }}
            />

            <TextField sx={uiLayout.formFieldSx} InputLabelProps={{ shrink: true }}
              select
              size="small"
              label="نوع البرنامج"
              value={programType}
              onChange={(e) => {
                setProgramType(e.target.value);
                resetBelowType();
              }}
            >
              {PROGRAMS.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </TextField>

            <TextField InputLabelProps={{ shrink: true }}
              size="small"
              label="الدفعة"
              value={batch?.name || ""}
              onClick={() => {
                if (!branch) {
                  Swal.fire("تنبيه", "اختر الفرع أولًا", "warning");
                  return;
                }

                if (programType === "") {
                  Swal.fire("تنبيه", "اختر نوع البرنامج أولًا", "warning");
                  return;
                }

                setBatchSearch("");
                setBatchDialogOpen(true);
              }}
              InputProps={{ readOnly: true }}
              sx={uiLayout.withUiSx({ gridColumn: { xs: "1 / -1", md: "auto" } }, uiLayout.formFieldSx)}
            />
          </Box>

          <Box
            sx={{
              mt: { xs: 0.55, sm: 0.8 },
              display: "grid",
              gridTemplateColumns: "repeat(2,minmax(0,1fr))",
              gap: { xs: 0.4, sm: 0.7 }
            }}
          >
            <Paper variant="outlined" sx={{ p: 0.6, textAlign: "center" }}>
              <Typography
                color="text.secondary"
                sx={{ fontSize: { xs: 12, sm: 12 } }}
              >
                المقاعد المتاحة
              </Typography>
              <Typography
                sx={{
                  fontWeight: 900,
                  color: "#d32f2f",
                  fontSize: { xs: 14, sm: 18 }
                }}
              >
                {mainCount}
              </Typography>
            </Paper>

            <Paper variant="outlined" sx={{ p: 0.6, textAlign: "center" }}>
              <Typography
                color="text.secondary"
                sx={{ fontSize: { xs: 12, sm: 12 } }}
              >
                المقاعد المتبقية
              </Typography>
              <Typography
                sx={{
                  fontWeight: 900,
                  color: remainingCount === 0 ? "#d32f2f" : primary,
                  fontSize: { xs: 14, sm: 18 }
                }}
              >
                {remainingCount}
              </Typography>
            </Paper>
          </Box>

          <Typography
            sx={{
              mt: { xs: 0.7, sm: 1 },
              mb: 0.45,
              textAlign: "center",
              fontWeight: 900,
              color: "#d32f2f",
              fontSize: { xs: 12, sm: 15 }
            }}
          >
            عدد الطلاب المتاح تسجيلهم في كل تخصص
          </Typography>

          <Paper
            variant="outlined"
            sx={{
              borderColor: isDark ? DARK_BORDER : border,
              overflow: "hidden"
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "minmax(0,1fr) 88px",
                bgcolor: "#e9f3ef",
                px: { xs: 0.45, sm: 0.75 },
                py: { xs: 0.42, sm: 0.6 },
                fontWeight: 900,
                fontSize: { xs: 12, sm: 12.5 }
              }}
            >
              <Box>التخصص</Box>
              <Box sx={{ textAlign: "center" }}>عدد الطلاب</Box>
            </Box>

            <Box
              sx={{
                maxHeight: { xs: "54vh", sm: 520 },
                overflow: "auto"
              }}
            >
              {specialties.map((item) => (
                <Box
                  key={item.guid}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "minmax(0,1fr) 88px",
                    gap: 0.4,
                    alignItems: "center",
                    px: { xs: 0.45, sm: 0.75 },
                    py: { xs: 0.3, sm: 0.45 },
                    borderTop: "1px solid #edf2ef"
                  }}
                >
                  <Typography
                    title={item.name}
                    sx={{
                      fontSize: { xs: 12, sm: 12.8 },
                      fontWeight: 750,
                      lineHeight: 1.35
                    }}
                  >
                    {item.name}
                  </Typography>

                  <TextField InputLabelProps={{ shrink: true }}
                    type="number"
                    size="small"
                    value={item.count}
                    onChange={(e) =>
                      setSpecialtyCount(item.guid, e.target.value)
                    }
                    inputProps={{
                      min: 0,
                      style: { textAlign: "center" , direction: "ltr", unicodeBidi: "isolate" }
                    , dir: "ltr" }}
                    sx={uiLayout.withUiSx({
                      "& .MuiInputBase-root": {
                        minHeight: { xs: 29, sm: 33 }
                      },
                      "& input": {
                        px: 0.25,
                        py: 0.2,
                        fontSize: { xs: 12, sm: 12 }
                      }
                    }, uiLayout.formFieldSx)}
                  />
                </Box>
              ))}

              {!loading && batch && specialties.length === 0 && (
                <Alert severity="info" sx={{ m: 0.6, fontSize: { xs: 12, sm: 12 } }}>
                  لا توجد تخصصات متاحة لهذا النوع.
                </Alert>
              )}
            </Box>
          </Paper>
        </Box>
      </Paper>

      <SelectDialog
        open={branchDialogOpen}
        title="قائمة الفروع"
        rows={branches}
        search={branchSearch}
        setSearch={setBranchSearch}
        loading={false}
        type="branch"
        onClose={() => setBranchDialogOpen(false)}
        onPick={(row) => {
          setBranch(row);
          setBranchDialogOpen(false);
          resetBelowBranch();
        }}
      />

      <SelectDialog
        open={batchDialogOpen}
        title={
          Number(programType) === 0
            ? "قائمة دفعات الدبلومات"
            : Number(programType) === 1
              ? "قائمة دفعات الدورات التأهيلية"
              : "قائمة دفعات الدورات التطويرية"
        }
        rows={batchRows}
        search={batchSearch}
        setSearch={setBatchSearch}
        loading={batchLoading}
        type="batch"
        onClose={() => setBatchDialogOpen(false)}
        onPick={loadDetails}
      />
    </Box>
  );

  return (
    <NavigationShell variant="standard" mobileOpen={mobileSidebarOpen} onMobileClose={() => setMobileSidebarOpen(false)}><Box className="sstli-dark-root" sx={{ display: "flex", minHeight: "100vh", bgcolor: theme.palette.mode === 'dark' ? theme.palette.background.default : soft }}>

      <GlobalStyles
        styles={{
          ...(isDark
            ? {
                ".sstli-dark-root": {
                  color: `${theme.palette.text.primary} !important`
                },

                ".sstli-dark-root .MuiPaper-root:not(.print-preview):not(.document-preview):not(.a4-page), .sstli-dark-root .MuiCard-root": {
                  backgroundColor: `${darkCard} !important`,
                  backgroundImage: "none !important",
                  color: `${theme.palette.text.primary} !important`,
                  borderColor: `${DARK_BORDER} !important`,
                  boxShadow: "none !important"
                },

                ".sstli-dark-root .MuiButton-root, .MuiDialog-paper .MuiButton-root, .MuiPopover-paper .MuiButton-root": {
                  backgroundColor: "transparent !important",
                  backgroundImage: "none !important",
                  color: `${DARK_TEXT} !important`,
                  border: `1px solid ${DARK_BORDER} !important`,
                  boxShadow: "none !important"
                },
                ".sstli-dark-root .MuiButton-root:hover, .MuiDialog-paper .MuiButton-root:hover, .MuiPopover-paper .MuiButton-root:hover": {
                  backgroundColor: "transparent !important",
                  backgroundImage: "none !important",
                  color: "#C9F2DF !important",
                  borderColor: `${DARK_BORDER} !important`,
                  boxShadow: "0 0 0 1px rgba(103,201,157,.16) !important"
                },
                ".sstli-dark-root .MuiButton-root.Mui-disabled, .MuiDialog-paper .MuiButton-root.Mui-disabled": {
                  backgroundColor: "transparent !important",
                  color: "rgba(155,224,193,.42) !important",
                  borderColor: "rgba(103,201,157,.34) !important",
                  boxShadow: "none !important"
                },

                ".sstli-dark-root .MuiIconButton-root, .MuiDialog-paper .MuiIconButton-root": {
                  backgroundColor: "transparent !important",
                  backgroundImage: "none !important",
                  color: `${DARK_TEXT} !important`,
                  border: `1px solid ${DARK_BORDER} !important`,
                  boxShadow: "none !important"
                },
                ".sstli-dark-root .MuiIconButton-root:hover, .MuiDialog-paper .MuiIconButton-root:hover": {
                  backgroundColor: "transparent !important",
                  color: "#C9F2DF !important"
                },

                ".sstli-dark-root .MuiChip-root, .MuiDialog-paper .MuiChip-root": {
                  backgroundColor: "transparent !important",
                  backgroundImage: "none !important",
                  color: `${DARK_TEXT} !important`,
                  border: `1px solid ${DARK_BORDER} !important`,
                  boxShadow: "none !important"
                },

                ".sstli-dark-root .MuiBadge-badge": {
                  backgroundColor: "transparent !important",
                  color: `${DARK_TEXT} !important`,
                  border: `1px solid ${DARK_BORDER} !important`
                },

                ".sstli-dark-root .MuiTabs-root, .MuiDialog-paper .MuiTabs-root": {
                  backgroundColor: `${darkSection} !important`,
                  backgroundImage: "none !important",
                  border: `1px solid ${DARK_BORDER} !important`,
                  borderRadius: "10px !important",
                  minHeight: "38px !important"
                },
                ".sstli-dark-root .MuiTab-root, .MuiDialog-paper .MuiTab-root": {
                  backgroundColor: "transparent !important",
                  backgroundImage: "none !important",
                  color: `${theme.palette.text.secondary} !important`,
                  border: "0 !important",
                  minHeight: "36px !important"
                },
                ".sstli-dark-root .MuiTab-root.Mui-selected, .MuiDialog-paper .MuiTab-root.Mui-selected": {
                  backgroundColor: "transparent !important",
                  color: `${DARK_TEXT} !important`
                },
                ".sstli-dark-root .MuiTabs-indicator, .MuiDialog-paper .MuiTabs-indicator": {
                  backgroundColor: `${DARK_BORDER} !important`,
                  height: "2px !important"
                },

                ".sstli-dark-root .MuiOutlinedInput-root, .MuiDialog-paper .MuiOutlinedInput-root, .MuiPopover-paper .MuiOutlinedInput-root": {
                  backgroundColor: "transparent !important",
                  backgroundImage: "none !important",
                  color: `${theme.palette.text.primary} !important`
                },
                ".sstli-dark-root .MuiOutlinedInput-notchedOutline, .MuiDialog-paper .MuiOutlinedInput-notchedOutline, .MuiPopover-paper .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${DARK_BORDER} !important`
                },
                ".sstli-dark-root .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, .sstli-dark-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiDialog-paper .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, .MuiDialog-paper .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${DARK_BORDER} !important`,
                  borderWidth: "1px !important"
                },
                ".sstli-dark-root .MuiInputLabel-root, .MuiDialog-paper .MuiInputLabel-root, .MuiPopover-paper .MuiInputLabel-root": {
                  color: `${theme.palette.text.secondary} !important`
                },
                ".sstli-dark-root .MuiInputLabel-root.Mui-focused, .MuiDialog-paper .MuiInputLabel-root.Mui-focused": {
                  color: `${DARK_TEXT} !important`
                },
                ".sstli-dark-root .MuiInputLabel-root.Mui-disabled, .MuiDialog-paper .MuiInputLabel-root.Mui-disabled": {
                  color: "rgba(155,224,193,.45) !important"
                },
                ".sstli-dark-root .MuiInputAdornment-root, .sstli-dark-root .MuiInputAdornment-root .MuiSvgIcon-root, .sstli-dark-root .MuiSelect-icon, .MuiDialog-paper .MuiSelect-icon": {
                  color: `${DARK_TEXT} !important`
                },
                ".sstli-dark-root .MuiFormHelperText-root, .MuiDialog-paper .MuiFormHelperText-root": {
                  color: `${theme.palette.text.secondary} !important`
                },

                ".sstli-dark-root .MuiCheckbox-root, .MuiDialog-paper .MuiCheckbox-root": {
                  color: `${DARK_BORDER} !important`
                },
                ".sstli-dark-root .MuiCheckbox-root.Mui-checked, .MuiDialog-paper .MuiCheckbox-root.Mui-checked": {
                  color: `${DARK_BORDER} !important`
                },

                ".sstli-dark-root .MuiSwitch-track": {
                  backgroundColor: "transparent !important",
                  border: `1px solid ${DARK_BORDER} !important`,
                  opacity: "1 !important"
                },
                ".sstli-dark-root .MuiSwitch-thumb": {
                  backgroundColor: `${DARK_TEXT} !important`,
                  boxShadow: "none !important"
                },

                ".sstli-dark-root .MuiAlert-root, .MuiDialog-paper .MuiAlert-root": {
                  backgroundColor: "transparent !important",
                  backgroundImage: "none !important",
                  color: `${theme.palette.text.primary} !important`,
                  border: `1px solid ${DARK_BORDER} !important`,
                  boxShadow: "none !important"
                },
                ".sstli-dark-root .MuiAlert-icon, .MuiDialog-paper .MuiAlert-icon": {
                  color: `${DARK_TEXT} !important`
                },

                ".sstli-dark-root .MuiDivider-root, .MuiDialog-paper .MuiDivider-root": {
                  borderColor: `${DARK_BORDER} !important`
                },

                ".sstli-dark-root .MuiCircularProgress-root, .MuiDialog-paper .MuiCircularProgress-root": {
                  color: `${DARK_BORDER} !important`
                },

                ".sstli-dark-root .MuiAppBar-root": {
                  backgroundColor: `${darkSection} !important`,
                  backgroundImage: "none !important",
                  color: `${theme.palette.text.primary} !important`,
                  borderBottom: `1px solid ${DARK_BORDER} !important`,
                  boxShadow: "none !important"
                },

                ".sstli-dark-root .MuiTableContainer-root": {
                  backgroundColor: `${darkCard} !important`,
                  backgroundImage: "none !important",
                  borderColor: `${DARK_BORDER} !important`
                },
                ".sstli-dark-root .MuiTableHead-root .MuiTableCell-root, .MuiDialog-paper .MuiTableHead-root .MuiTableCell-root": {
                  backgroundColor: `${darkNested} !important`,
                  backgroundImage: "none !important",
                  color: `${theme.palette.text.primary} !important`,
                  borderColor: `${DARK_BORDER} !important`
                },
                ".sstli-dark-root .MuiTableBody-root .MuiTableCell-root, .MuiDialog-paper .MuiTableBody-root .MuiTableCell-root": {
                  backgroundColor: `${darkCard} !important`,
                  color: `${theme.palette.text.primary} !important`,
                  borderColor: "rgba(103,201,157,.24) !important"
                },
                ".sstli-dark-root .MuiTableRow-root:hover .MuiTableCell-root, .MuiDialog-paper .MuiTableRow-root:hover .MuiTableCell-root": {
                  backgroundColor: `${darkHover} !important`
                },

                ".sstli-dark-root .MuiPaginationItem-root": {
                  backgroundColor: "transparent !important",
                  color: `${DARK_TEXT} !important`,
                  border: `1px solid ${DARK_BORDER} !important`
                },
                ".sstli-dark-root .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "transparent !important",
                  color: "#C9F2DF !important",
                  boxShadow: `inset 0 0 0 1px ${DARK_BORDER} !important`
                },

                ".MuiDialog-paper": {
                  backgroundColor: `${darkCard} !important`,
                  backgroundImage: "none !important",
                  color: `${theme.palette.text.primary} !important`,
                  border: `1px solid ${DARK_BORDER} !important`,
                  boxShadow: "0 18px 50px rgba(2,18,12,.34) !important"
                },
                ".MuiDialogTitle-root": {
                  backgroundColor: `${darkSection} !important`,
                  backgroundImage: "none !important",
                  color: `${theme.palette.text.primary} !important`,
                  borderBottom: `1px solid ${DARK_BORDER} !important`
                },
                ".MuiDialogContent-root": {
                  backgroundColor: `${darkCard} !important`,
                  color: `${theme.palette.text.primary} !important`
                },
                ".MuiDialogActions-root": {
                  backgroundColor: `${darkSection} !important`,
                  color: `${theme.palette.text.primary} !important`,
                  borderTop: `1px solid ${DARK_BORDER} !important`
                },
                ".MuiDialog-paper .MuiPaper-root, .MuiDialog-paper .MuiCard-root": {
                  backgroundColor: `${darkSection} !important`,
                  backgroundImage: "none !important",
                  color: `${theme.palette.text.primary} !important`,
                  borderColor: `${DARK_BORDER} !important`
                },
                ".MuiDialog-paper .MuiPaper-root:hover, .MuiDialog-paper .MuiCard-root:hover": {
                  backgroundColor: `${darkHover} !important`
                },

                ".MuiMenu-paper, .MuiPopover-paper, .MuiAutocomplete-paper": {
                  backgroundColor: `${darkSection} !important`,
                  backgroundImage: "none !important",
                  color: `${theme.palette.text.primary} !important`,
                  border: `1px solid ${DARK_BORDER} !important`,
                  boxShadow: "0 14px 34px rgba(3,20,13,.28) !important"
                },
                ".MuiMenuItem-root, .MuiAutocomplete-option": {
                  backgroundColor: "transparent !important",
                  color: `${theme.palette.text.primary} !important`
                },
                ".MuiMenuItem-root:hover, .MuiAutocomplete-option:hover": {
                  backgroundColor: `${darkHover} !important`
                },
                ".MuiMenuItem-root.Mui-selected, .MuiAutocomplete-option[aria-selected='true']": {
                  backgroundColor: "transparent !important",
                  color: `${DARK_TEXT} !important`,
                  borderInlineStart: `2px solid ${DARK_BORDER} !important`
                },

                ".swal2-popup": {
                  backgroundColor: `${darkCard} !important`,
                  backgroundImage: "none !important",
                  color: `${theme.palette.text.primary} !important`,
                  border: `1px solid ${DARK_BORDER} !important`,
                  boxShadow: "0 18px 50px rgba(2,18,12,.34) !important"
                },
                ".swal2-title, .swal2-html-container, .swal2-input-label": {
                  color: `${theme.palette.text.primary} !important`
                },
                ".swal2-confirm, .swal2-deny, .swal2-cancel": {
                  backgroundColor: "transparent !important",
                  backgroundImage: "none !important",
                  color: `${DARK_TEXT} !important`,
                  border: `1px solid ${DARK_BORDER} !important`,
                  boxShadow: "none !important"
                },
                ".swal2-confirm:hover, .swal2-deny:hover, .swal2-cancel:hover": {
                  backgroundColor: "transparent !important",
                  color: "#C9F2DF !important"
                },
                ".swal2-input, .swal2-textarea, .swal2-select": {
                  backgroundColor: "transparent !important",
                  color: `${theme.palette.text.primary} !important`,
                  border: `1px solid ${DARK_BORDER} !important`,
                  boxShadow: "none !important"
                },
                ".swal2-validation-message": {
                  backgroundColor: `${darkSection} !important`,
                  color: `${theme.palette.text.primary} !important`
                },

                ".sstli-dark-root input[type='date'], .MuiDialog-paper input[type='date'], .sstli-dark-root input[type='datetime-local'], .MuiDialog-paper input[type='datetime-local'], .sstli-dark-root input[type='time'], .MuiDialog-paper input[type='time']": {
                  colorScheme: "dark"
                },

                ".sstli-dark-root .print-preview, .sstli-dark-root .document-preview, .sstli-dark-root .a4-page": {
                  backgroundColor: "#fff !important",
                  backgroundImage: "none !important",
                  color: "#111 !important",
                  borderColor: "#ddd !important"
                }
              }
            : {})
        }}
      />

      

      

      <Box sx={{
        flex: 1,
        minWidth: 0,
        ...navigationContentSx
      }}>{page}</Box>
    </Box></NavigationShell>
  );
}
